import { render, staticRenderFns } from "./ClientsGestion.vue?vue&type=template&id=870dd74c&"
import script from "./ClientsGestion.vue?vue&type=script&lang=js&"
export * from "./ClientsGestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports